module.exports = __webpack_public_path__ + "img/first.ee0be0fe.jpg";